module.exports = __webpack_public_path__ + "assets/clear_search-6046d7.svg";